import React from 'react';
import Footer from '../../components/footer';
import Navbar from '../../components/navbar';

const TermsPage = () => (
  <div className="terms-page page-with-navbar-footer">
    <Navbar />
    <main className="terms-content" style={{ minHeight: '60vh', padding: '40px 0', background: '#181818', color: '#fff' }}>
      <div className="container" style={{ maxWidth: 800, margin: '40px auto', padding: 24 }}>
        <h1 style={{ fontFamily: 'Orbitron, monospace', color: '#FFD700', fontWeight: 800 }}>Terms & Conditions</h1>
        <p style={{ marginTop: 24 }}>
          <b>Effective Date: 2024-05-01</b>
        </p>
        <h2>1. Acceptance of Terms</h2>
        <p>By accessing or using Cheda Gaming, you agree to these Terms & Conditions and all applicable laws of Kenya.</p>
        <h2>2. Eligibility</h2>
        <p>You must be at least 18 years old to use our platform and participate in tournaments.</p>
        <h2>3. Account Registration</h2>
        <ul>
          <li>You agree to provide accurate and complete information when creating an account.</li>
          <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
        </ul>
        <h2>4. Tournaments & Prizes</h2>
        <ul>
          <li>Participation in tournaments is subject to the specific rules of each event.</li>
          <li>Prizes will be awarded as described in the tournament details and may be subject to verification and local laws.</li>
        </ul>
        <h2>5. Payments</h2>
        <ul>
          <li>All payments are processed securely via third-party providers.</li>
          <li>By making a payment, you agree to the provider's terms and conditions.</li>
        </ul>
        <h2>6. User Conduct</h2>
        <ul>
          <li>You agree not to use Cheda Gaming for unlawful, abusive, or fraudulent activities.</li>
          <li>Harassment, cheating, or exploitation of the platform or other users is strictly prohibited.</li>
        </ul>
        <h2>7. Intellectual Property</h2>
        <p>All content, trademarks, and logos on Cheda Gaming are the property of Cheda Gaming or its licensors. You may not use them without permission.</p>
        <h2>8. Disclaimers</h2>
        <p>Cheda Gaming is provided "as is" without warranties of any kind. We do not guarantee uninterrupted or error-free service.</p>
        <h2>9. Limitation of Liability</h2>
        <p>To the fullest extent permitted by law, Cheda Gaming is not liable for any indirect, incidental, or consequential damages arising from your use of the platform.</p>
        <h2>10. Changes to Terms</h2>
        <p>We may update these Terms & Conditions at any time. Continued use of the platform constitutes acceptance of the new terms.</p>
        <h2>11. Governing Law</h2>
        <p>These Terms are governed by the laws of Kenya.</p>
        <h2>12. Contact Us</h2>
        <p>If you have questions about these Terms, contact us at <a href="mailto:support@chedagaming.com" style={{ color: '#FFD700' }}>support@chedagaming.com</a>.</p>
      </div>
    </main>
    <Footer />
  </div>
);

export default TermsPage; 